module.exports = __webpack_public_path__ + "static/media/photostick-mobile-android.64c688d2.png";